/**
 * Расписание попыток автопродления относительно lastTariffExpiresAt
 * (как в go-server transaction/model/renewalSchedule.go):
 * 1) за 24ч до окончания, 2) в момент окончания, 3) через 24ч после.
 */
const RENEWAL_ATTEMPT_OFFSETS_MS = [
  -24 * 60 * 60 * 1000,
  0,
  24 * 60 * 60 * 1000,
] as const

/**
 * Возвращает время ближайшего автосписания.
 * Предпочитает nextChargeAt с бэка; иначе считает по offset'ам от lastTariffExpiresAt.
 */
export function resolveNextChargeAt(
  nextChargeAt: number | null | undefined,
  lastTariffExpiresAt: number | null | undefined,
  nowMs: number = Date.now(),
): number | null {
  if (nextChargeAt != null && nextChargeAt > nowMs) {
    return nextChargeAt
  }

  if (lastTariffExpiresAt == null) return null

  for (const offsetMs of RENEWAL_ATTEMPT_OFFSETS_MS) {
    const attemptAt = lastTariffExpiresAt + offsetMs
    if (attemptAt > nowMs) return attemptAt
  }

  return null
}
